<template>
  <div class="PublishData">
    <div class="row justify-content-start align-items-start px-4" style="text-align:start">
      <div class="col-md-12">
        <br />

        <p style="white-space: pre-line;">
          {{ $t('publishData.intro') }}
        </p>

        <p>
          {{ $t('publishData.consentPrompt') }}
        </p>

        <MDBRadio
            :label="$t('common.yes')"
            name="consent-share"
            v-model="consentShareData"
            value="true"
        />
        <MDBRadio
            :label="$t('common.no')"
            name="consent-share"
            v-model="consentShareData"
            value="false"
        />

        <br />

        <p>{{ $t('publishData.preferencePrompt') }}</p>

        <MDBRadio
            :label="$t('publishData.preference.includeNameCountry')"
            name="consent-name"
            v-model="consentIncludeName"
            value="true"
        />
        <MDBRadio
            :label="$t('publishData.preference.anonymous')"
            name="consent-name"
            v-model="consentIncludeName"
            value="false"
        />
      </div>
    </div>
  </div>
</template>

<script src="./_PublishData.js" lang="js"></script>
<style src="./_PublishData.less" lang="less" scoped></style>
